import gql from 'graphql-tag';

export const CloneParticipantNote = gql`
  mutation CloneParticipantNote(
    $organizationId: ID!
    $participantId: ID!
    $participantNoteId: ID!
  ) {
    cloneParticipantNote(organizationId: $organizationId, participantId: $participantId, participantNoteId: $participantNoteId) {
      id
    }
  }
`;
